const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'exams',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.exams" */ '@/views/Exams'),
  },
  meta: {
    breadcrumb: {
      label: 'Exams',
    },
  },
  children: [
    {
      path: '',
      name: 'exams-listing',
      component: () => import(/* webpackChunkName: "module.exams.list" */ '@/modules/Exams/List'),
      meta: {
        breadcrumb: {
          label: 'Exams',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'exams-edit',
      component: () => import(/* webpackChunkName: "module.exams.edition" */ '@/modules/Exams/Edition'),
      meta: {
        breadcrumb: {
          parent: 'exams-listing',
          label: 'Edit Exam',
        },
      },
    },
    {
      path: 'create',
      name: 'exams-create',
      component: () => import(/* webpackChunkName: "module.exams.edition" */ '@/modules/Exams/Edition'),
      meta: {
        breadcrumb: {
          parent: 'exams-listing',
          label: 'Create Exam',
        },
      },
    },
  ],
};
